export enum PeriodRentLabel {
    AVAILABLE_FROM = 'Frei ab',
    AVAILABLE_TO = 'Frei bis',
    LEASE_MIN = 'Min. Mietdauer',
    LEASE_MAX = 'Max. Mietdauer',
}

export enum PeriodOfLeaseText {
    NO_INFO = 'keine Angaben',
    FROM_PREFIX = 'Ab',
    TO_PREFIX = 'Bis',
    MIN_PREFIX = 'min.',
    MAX_PREFIX = 'max.',
}
